import { uz } from "@/shared/i18n/uz.js";

const CAPACITY = 10;
const TAKEN = 8;

/**
 * Hero'dagi asosiy tasvir — ilova guruhga yuboradigan kartochkaning o'zi.
 *
 * Bu "mahsulot skrinshoti" emas, balki mahsulotning haqiqiy natijasi:
 * o'quvchi nima olishini darhol ko'radi. O'rinlar tasmasi Mini App bilan
 * bir xil — ikkala sirt bitta til bilan gapiradi.
 */
export function MatchCard() {
  return (
    <div className="border-night-line bg-night-2 w-full max-w-sm rounded-2xl border p-5 shadow-2xl shadow-black/30">
      <p className="text-gold font-cond text-sm font-semibold tracking-wider">{uz.card.when}</p>
      <p className="text-night-ink mt-1 text-xl font-semibold">{uz.card.venue}</p>
      <p className="text-night-hint mt-0.5 text-sm">{uz.card.meta}</p>

      <div className="mt-5 flex items-baseline justify-between">
        <span className="text-night-ink tabular text-lg font-bold">
          {TAKEN}
          <span className="text-night-hint font-medium">/{CAPACITY}</span>
        </span>
        <span className="text-night-hint text-sm">{uz.card.need}</span>
      </div>

      {/*
        Yagona harakat: sahifa ochilganda tasma to'ladi. U mahsulotning
        asosiy hodisasini ko'rsatadi — odamlar yozilib borishini.
      */}
      <div
        role="img"
        aria-label={`${CAPACITY} o'rindan ${TAKEN} tasi band`}
        className="mt-2 flex h-3.5 w-full gap-[3px]"
      >
        {Array.from({ length: CAPACITY }, (_, index) => (
          <span
            key={index}
            style={index < TAKEN ? { animationDelay: `${180 + index * 70}ms` } : undefined}
            className={`min-w-[3px] flex-1 rounded-[3px] ${
              index < TAKEN
                ? "bg-green motion-safe:animate-[slot-fill_320ms_ease-out_both]"
                : "border-night-line border"
            }`}
          />
        ))}
      </div>

      <div className="mt-5 grid grid-cols-2 gap-2">
        <span className="bg-green rounded-lg py-2 text-center text-sm font-semibold text-white">
          {uz.card.join}
        </span>
        <span className="border-night-line text-night-hint rounded-lg border py-2 text-center text-sm font-semibold">
          {uz.card.decline}
        </span>
      </div>

      <ul className="border-night-line mt-4 flex flex-col gap-1.5 border-t pt-4">
        {["Sardor K.", "Jasur T.", "Bekzod S."].map((name, index) => (
          <li key={name} className="text-night-hint flex items-center gap-2.5 text-sm">
            <span className="tabular w-3 text-right text-xs">{index + 1}</span>
            <span className="border-night-line flex h-6 w-6 items-center justify-center rounded-full border text-[10px] font-semibold">
              {name.slice(0, 1)}
            </span>
            <span className="text-night-ink">{name}</span>
          </li>
        ))}
        <li className="text-night-hint pl-[1.4rem] text-sm">+5 …</li>
      </ul>
    </div>
  );
}
